import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Sparkles, LogOut, User, Menu, X, LayoutDashboard } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import SmartHireCTA from "../SmartHireCTA";

const linkCls = ({ isActive }) =>
  `text-sm transition animated-underline ${isActive ? "text-slate-900 font-medium" : "text-slate-500 hover:text-slate-900"}`;

const mobileLinkCls = ({ isActive }) =>
  `block py-2 text-sm transition ${isActive ? "text-violet-600 font-medium" : "text-slate-600 hover:text-slate-900"}`;

export default function Navbar() {
  const { user, isAuthenticated, logout } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className="containerX py-4">
        <div className="glass px-4 py-3 flex items-center justify-between">
          <NavLink to="/" className="flex items-center gap-3">
            <img
              src="/logo.jpeg"
              alt="hirrd logo"
              className="h-9 w-9 rounded-xl object-cover"
            />
            <div className="leading-tight">
              <div className="font-semibold tracking-tight text-slate-900">hirrd</div>
              <div className="text-xs text-slate-400 -mt-0.5">Startup Talent</div>
            </div>
          </NavLink>

          <nav className="hidden md:flex items-center gap-6">
            <NavLink to="/employers" className={linkCls}>Employers</NavLink>
            <NavLink to="/candidates" className={linkCls}>Candidates</NavLink>
            <NavLink to="/about" className={linkCls}>About</NavLink>
            <NavLink to="/team" className={linkCls}>Our Team</NavLink>
            <NavLink to="/contact" className={linkCls}>Contact</NavLink>
            {isAuthenticated && user?.role === "company" && (
              <NavLink to="/company/matches" className={linkCls}>
                <span className="inline-flex items-center gap-1"><LayoutDashboard size={14} /> Dashboard</span>
              </NavLink>
            )}
          </nav>

          <div className="flex items-center gap-2">
            {isAuthenticated ? (
              <>
                <div className="hidden sm:flex items-center gap-2 text-sm text-slate-600">
                  <div className="h-8 w-8 rounded-full bg-violet-100 flex items-center justify-center">
                    <User size={14} className="text-violet-600" />
                  </div>
                  <span className="hidden md:inline font-medium">
                    {user?.profile?.full_name || user?.profile?.company_name || user?.email}
                  </span>
                </div>
                <button onClick={logout} className="btn btnGhost text-sm">
                  <LogOut size={14} /> <span className="hidden sm:inline">Log out</span>
                </button>
              </>
            ) : (
              <>
                <NavLink to="/contact" className="btn btnGhost hidden sm:flex">
                  <Sparkles size={16} /> Book a call
                </NavLink>
                <SmartHireCTA label="Hire now" className="btn btnPrimary hidden sm:flex" />
              </>
            )}

            {/* Mobile menu toggle */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden p-1.5 rounded-lg hover:bg-slate-100 transition"
            >
              {mobileOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden glass mt-2 p-4 animate-in fade-in slide-in-from-top-2 duration-200">
            <nav className="grid gap-1">
              <NavLink to="/employers" className={mobileLinkCls} onClick={() => setMobileOpen(false)}>Employers</NavLink>
              <NavLink to="/candidates" className={mobileLinkCls} onClick={() => setMobileOpen(false)}>Candidates</NavLink>
              <NavLink to="/about" className={mobileLinkCls} onClick={() => setMobileOpen(false)}>About</NavLink>
              <NavLink to="/team" className={mobileLinkCls} onClick={() => setMobileOpen(false)}>Our Team</NavLink>
              <NavLink to="/contact" className={mobileLinkCls} onClick={() => setMobileOpen(false)}>Contact</NavLink>
              {isAuthenticated && user?.role === "company" && (
                <NavLink to="/company/matches" className={mobileLinkCls} onClick={() => setMobileOpen(false)}>
                  <span className="inline-flex items-center gap-1"><LayoutDashboard size={14} /> Dashboard</span>
                </NavLink>
              )}
            </nav>
            <div className="mt-3 pt-3 border-t grid gap-2" style={{ borderColor: "rgba(226,232,240,0.5)" }}>
              {isAuthenticated ? (
                <button onClick={() => { logout(); setMobileOpen(false); }} className="btn btnGhost justify-center text-sm">
                  <LogOut size={14} /> Log out
                </button>
              ) : (
                <>
                  <SmartHireCTA label="Hire now" className="btn btnPrimary justify-center" />
                  <NavLink to="/contact" className="btn btnGhost justify-center" onClick={() => setMobileOpen(false)}>
                    <Sparkles size={16} /> Book a call
                  </NavLink>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
